/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Import_Format_HintInputs */

const en_resumes_import_format_hint = /** @type {(inputs: Resumes_Import_Format_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF and DOCX files supported. AI will extract your details automatically.`)
};

const de_resumes_import_format_hint = /** @type {(inputs: Resumes_Import_Format_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF- und DOCX-Dateien werden unterstützt. KI extrahiert deine Daten automatisch.`)
};

const fr_resumes_import_format_hint = /** @type {(inputs: Resumes_Import_Format_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichiers PDF et DOCX pris en charge. L'IA extraira tes informations automatiquement.`)
};

const es_resumes_import_format_hint = /** @type {(inputs: Resumes_Import_Format_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se admiten archivos PDF y DOCX. La IA extraerá sus datos automáticamente.`)
};

const it_resumes_import_format_hint = /** @type {(inputs: Resumes_Import_Format_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File PDF e DOCX supportati. L'AI estrarrà automaticamente i tuoi dettagli.`)
};

const nl_resumes_import_format_hint = /** @type {(inputs: Resumes_Import_Format_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF- en DOCX-bestanden ondersteund. AI extraheert automatisch je gegevens.`)
};

const pl_resumes_import_format_hint = /** @type {(inputs: Resumes_Import_Format_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsługiwane pliki PDF i DOCX. AI automatycznie wyodrębni Twoje dane.`)
};

const fi_resumes_import_format_hint = /** @type {(inputs: Resumes_Import_Format_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF- ja DOCX-tiedostot tuettu. Tekoäly poimii tiedot automaattisesti.`)
};

const da_resumes_import_format_hint = /** @type {(inputs: Resumes_Import_Format_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF- og DOCX-filer understøttet. AI udtrækker dine detaljer automatisk.`)
};

const sv_resumes_import_format_hint = /** @type {(inputs: Resumes_Import_Format_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF- och DOCX-filer stöds. AI extraherar dina uppgifter automatiskt.`)
};

/**
* | output |
* | --- |
* | "PDF and DOCX files supported. AI will extract your details automatically." |
*
* @param {Resumes_Import_Format_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_import_format_hint = /** @type {((inputs?: Resumes_Import_Format_HintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Import_Format_HintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_import_format_hint(inputs)
	if (locale === "fr") return fr_resumes_import_format_hint(inputs)
	if (locale === "es") return es_resumes_import_format_hint(inputs)
	if (locale === "it") return it_resumes_import_format_hint(inputs)
	if (locale === "nl") return nl_resumes_import_format_hint(inputs)
	if (locale === "pl") return pl_resumes_import_format_hint(inputs)
	if (locale === "fi") return fi_resumes_import_format_hint(inputs)
	if (locale === "da") return da_resumes_import_format_hint(inputs)
	if (locale === "sv") return sv_resumes_import_format_hint(inputs)
	return en_resumes_import_format_hint(inputs)
});